import { ConfiguratorUIElementEvent, ConfiguratorUIElementEventListener } from './events';
import { IUiCfgContainer } from '@canvas-logic/clp-api-types';
import React from 'react';

export abstract class CfgUIElementState {
  id = '';
  protected listeners: ConfiguratorUIElementEventListener[] = [];

  addEventListener(listener: ConfiguratorUIElementEventListener) {
    this.listeners.push(listener);
  }

  removeEventListener(listener: ConfiguratorUIElementEventListener) {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  removeEventListeners() {
    this.listeners = [];
  }

  notify(event: ConfiguratorUIElementEvent) {
    this.listeners.forEach((listener) => listener(event));
  }

  update(): void {}

  abstract render(): React.ReactNode;
}

export abstract class ConfiguratorUIElementWithChildrenState extends CfgUIElementState {
  protected constructor(public children: ConfiguratorUIElementStates[], public viewElement: IUiCfgContainer) {
    super();
  }
}

export type ConfiguratorUIElementStates = CfgUIElementState | ConfiguratorUIElementWithChildrenState;
